// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-96.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-96.use[2]!../../node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-96.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SimpleDrag.vue?vue&type=style&index=0&id=f1719b00&lang=css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("73bbfb70", content, true, {"sourceMap":false,"shadowMode":false});